import Container from '@ui/container/container';
import { useAppSelector } from '@/store/hooks';
import { selectUserChannel } from '@/store/slices/user/selectors';
import { isWebinarChannel } from '@/utils/project-types/project-type-guards';

const webinarPlusLoaderGif = `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/images/webinar-plus-loader-grey.gif`;
const brandliveLoaderGif = `${import.meta.env.VITE_ASSET_SERVER}/bl-platform/images/brandlive-loader-grey.gif`;

const BrandedLoadingIndicator = () => {
  const userChannel = useAppSelector(selectUserChannel);
  const channelIsWebinar =
    (userChannel && isWebinarChannel(userChannel?.type)) || window.location.pathname.startsWith('/webinarplus');

  const loadingGifSrc = channelIsWebinar ? webinarPlusLoaderGif : brandliveLoaderGif;

  return (
    <Container className="flex jc-center ai-center" height="100%" width="100%" background="transparent">
      <img className="max-height-30-vh" src={loadingGifSrc} />
    </Container>
  );
};

export default BrandedLoadingIndicator;
